
import React from 'react';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { useDispatch } from 'react-redux';

import ToolButton from '../toolbar/ToolButton';
import buttonCommandClick from './buttonCommandClick';

const ButtonCommandZoomIn = (props) => {

    const dispatch = useDispatch();
    const onClick = () => {
        buttonCommandClick(dispatch, 'ZOOM_IN', null, props.actionType);
    }

    return (
        <IconButton
            className={ToolButton.TOOL_STYLE_UP}
            iconProps={ToolButton.getIcon('Add')}
            styles={{
                root: { color: '#FFFFFF' },
                rootHovered: { color: '#323436' },
            }}
            title="Přiblížit"
            onClick={onClick}
        />
    );
}

export default ButtonCommandZoomIn;
